<template>
  <div class="wrapper max30 ">
      <div>
        项目名称：
        <span style="position: relative">
        <Select class="input" v-model="projectFids" @on-change="checkAll" >
          <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
        </Select>
    </span>
  </div>
  <div>
    房型名称：
    <span style="position: relative">
    <Select class="input" v-model="houseTypeFid">
      <Option value="" >全部</Option>
      <Option v-for="(item,index) in houseTypeList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
    </Select>
      </span>
  </div>

  <date-public ref="datePublic"></date-public>
  <Button type="primary" style="margin-left: 20px" @click="ok">确定</Button>
  </div>
</template>

<script>
  import {getProjects} from "../../../api/common";
  import   {getHouseType } from "api/house"
  import DatePublic from './DatePublic'
  export default {
    name: "SearchList",
    data(){
      return {
        projectList:[],
        houseTypeList:[],
        projectFids:'',
        houseTypeFid:'',
        selectedAll: true
      }
    },
    components:{
      DatePublic
    },
    methods: {
      ok() {
        if (this.projectFids === '') {
          this.$Message.info('所选项目为空')
          return
        }
        this.sendParams()
      },
      sendParams() {
        let dateParams = this.$refs['datePublic'].dataToSend

        let params = {
          projectFids: this.projectFids,
          houseTypeFid: this.houseTypeFid,
          ...dateParams,
          current: this.$refs['datePublic'].current
        }

        this.$emit('getdata', params)

      },
      getProjects() {
        getProjects().then(res => {
          if (!res.data) {
            return
          }
          this.projectList = res.data
          if (this.projectList && this.projectList.length > 0) {
            var values = [];
            for (var property in this.projectList){
              values.push(this.projectList[property].value);
            }
            this.projectFids = values[0]
            this.checkAll();
            this.sendParams()
          }

        }).catch(error => {
        })
      },
      checkAll(){
          getHouseType(this.projectFids).then(res => {
                     this.houseTypeList = res.data.houseTypeList
            })
      }

    },

      created() {
        this.getProjects()
      }

  }
</script>

<style scoped>

  .input{
    display: inline-block;
    width: 300px;
    margin-right: 20px;
  }
  .wrapper{
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
  }
  .badge{
    position: absolute;
    top: -5px;
    right: -15px;
  }

</style>
